import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    transformHttpResponse,
} from 'utils';

/**
 * The judges of a competition (17 Oct 2026): read, add, mark (chief, deputy,
 * «у звітах») and remove. Promises the caller awaits — the list lives in the
 * form that shows it, re-read after every change. A rejection carries the
 * backend's message (a second chief, the same judge twice…).
 */
const rejectWithMessage = error => {
    const data = error.response && error.response.data;
    const violations = data && data.violations;
    return Promise.reject(new Error(
        (violations && violations.length && violations[0].message)
        || (data && (data['hydra:description'] || data.detail || data.message))
        || 'Save failed'
    ));
};

export const fetchCompetitionReferees = competitionId => () =>
    axios(apiRequestOptions(apiPath.COMPETITION_REFEREES.LIST, { competition: '/api/competitions/' + competitionId, pagination: false }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(rejectWithMessage);

export const addCompetitionReferee = (competitionId, refereeId) => () =>
    axios(apiRequestOptions(apiPath.COMPETITION_REFEREES.POST, {
        competition: '/api/competitions/' + competitionId,
        referee: '/api/referees/' + refereeId,
    }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(rejectWithMessage);

export const patchCompetitionReferee = (id, changes) => () =>
    axios(apiRequestOptions(apiPath.COMPETITION_REFEREES.PATCH, changes, { params: { id } }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(rejectWithMessage);

export const removeCompetitionReferee = id => () =>
    axios(apiRequestOptions(apiPath.COMPETITION_REFEREES.DELETE, null, { params: { id } }))
        .catch(rejectWithMessage);
